import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex gap-y-2 flex-col pb-2" }
const _hoisted_3 = { class: "flex flex-row justify-center gap-x-10 py-3 px-10 border-2 border-black-lp-200-opacity-50 rounded-lg" }
const _hoisted_4 = { class: "flex flex-row py-3 w-full gap-2 items-start" }
const _hoisted_5 = { class: "flex items-start" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "font-semibold text-14px text-gray-lp-300" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "h-fit vertical-line" }, null, -1)
const _hoisted_9 = { class: "flex flex-row py-3 gap-2 w-full items-start" }
const _hoisted_10 = { class: "flex items-start" }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = { class: "font-semibold text-14px text-gray-lp-300" }
const _hoisted_13 = { class: "flex flex-row gap-2 items-start" }
const _hoisted_14 = { class: "flex flex-col items-center gap-3" }
const _hoisted_15 = {
  key: 0,
  class: "vertical-line-connector"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_ctx.modalStatus)
    ? (_openBlock(), _createBlock(_component_ModalV2, {
        key: 0,
        title: _ctx.$t('pusatResolusi.statusReport'),
        onClose: _ctx.onClose,
        showFooter: false
      }, {
        content: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('pusatResolusi.create.noKendala'),
                value: _ctx.detailData.caseNumber ? _ctx.detailData.caseNumber : _ctx.detailData.ticketNoSf
              }, null, 8, ["label", "value"]),
              _createVNode(_component_DataWrapper, {
                label: "Genesis ID",
                value: _ctx.detailData.ticketNoGenesis
              }, null, 8, ["value"]),
              _createVNode(_component_DataWrapper, {
                customStyleValue: `my-1 font-normal break-words text-red-lp-100`,
                label: _ctx.$t('pusatResolusi.sttIssue'),
                value: _ctx.detailData.sttOrShipmentNo
              }, null, 8, ["label", "value"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('pusatResolusi.category'),
                value: _ctx.detailData.category
              }, null, 8, ["label", "value"])
            ]),
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_Icons, {
                    name: "profile-gray",
                    class: "text-gray-lp-600 w-4"
                  })
                ]),
                _createVNode("div", _hoisted_6, [
                  _createVNode("p", {
                    class: `w-1/2 pb-1 text-gray-lp-600 text-${_ctx.fontSize}px`
                  }, _toDisplayString(_ctx.$t('pusatResolusi.sender')), 3),
                  _createVNode("p", _hoisted_7, _toDisplayString(_ctx.detailData.senderName) + ", " + _toDisplayString(_ctx.detailData.senderPhoneNumber), 1),
                  _createVNode(_component_DataWrapper, {
                    value: _ctx.detailData.senderAddress
                  }, null, 8, ["value"])
                ])
              ]),
              _hoisted_8,
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode(_component_Icons, {
                    name: "location-gray",
                    class: "text-gray-lp-600 w-4"
                  })
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode("p", {
                    class: `w-1/2 pb-1 text-gray-lp-600 text-${_ctx.fontSize}px`
                  }, _toDisplayString(_ctx.$t('pusatResolusi.receiver')), 3),
                  _createVNode("p", _hoisted_12, _toDisplayString(_ctx.detailData.recipientName) + ", " + _toDisplayString(_ctx.detailData.recipientPhoneNumber), 1),
                  _createVNode(_component_DataWrapper, {
                    value: _ctx.detailData.recipientAddress
                  }, null, 8, ["value"])
                ])
              ])
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.statusHistory.slice().reverse(), (item, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "flex flex-col mt-4",
                key: index
              }, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", {
                      class: index === 0 ? `bg-red-lp-100 p-1 rounded-md` : `bg-gray-lp-1300 p-1 rounded-md`
                    }, [
                      (index+1 !== _ctx.detailData.statusHistory.length)
                        ? (_openBlock(), _createBlock(_component_Icons, {
                            key: 0,
                            name: "task-white",
                            class: "w-5"
                          }))
                        : (_openBlock(), _createBlock(_component_Icons, {
                            key: 1,
                            name: "send-white",
                            class: _ctx.detailData.statusHistory.length > 1 ? 'text-gray-lp-1300 w-5' : 'text-red-lp-100 w-5'
                          }, null, 8, ["class"]))
                    ], 2),
                    (index+1 !== _ctx.detailData.statusHistory.length)
                      ? (_openBlock(), _createBlock("div", _hoisted_15))
                      : _createCommentVNode("", true)
                  ]),
                  (index+1 !== _ctx.detailData.statusHistory.length)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 0,
                        label: _ctx.formatDate(item.statusHistoryCreatedAt),
                        class: "w-1/3",
                        value: _ctx.detailData.caseOwner ? `${item.statusHistoryDescription} (${_ctx.$t('pusatResolusi.csName')}: ${_ctx.detailData.caseOwner})` : item.statusHistoryDescription
                      }, null, 8, ["label", "value"]))
                    : (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 1,
                        label: _ctx.formatDate(item.statusHistoryCreatedAt),
                        class: "w-1/3",
                        value: item.statusHistoryDescription
                      }, null, 8, ["label", "value"]))
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["title", "onClose"]))
    : _createCommentVNode("", true)
}